import Image from "next/image";
import { FaCheck } from "react-icons/fa";
import Head from "next/head";

export default function NosEngagements() {
  return (
    <div className="bg-white text-black">
      <Head>
        <title>Nos engagements – MonTransfert Sàrl</title>
      </Head>

      <div className="bg-white">
        {/* Banner Section */}
        <div className="relative w-full h-[400px]">
          {/* Background Image */}
          <Image
            src="/images/apropos.jpg"
            alt="Nos engagements"
            fill
            className="object-cover"
            quality={100}
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* Title */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-6">
            <h1 className="text-5xl font-bold">Nos engagements</h1>
          </div>
        </div>

        {/* Content Section */}
        <section className="py-12 max-w-7xl mx-auto w-[90%] space-y-8 text-gray-900">
          <p>
            Chez MonTransfert, nous pensons que le véritable luxe ne se limite pas
            au confort d’un véhicule : il se vit dans chaque détail de l’expérience client.
          </p>

          <p>
            C’est pourquoi nous nous engageons à vous offrir bien plus qu’un simple trajet : un service irréprochable, une tranquillité d’esprit et une attention de chaque instant.
          </p>

          <h2 className="text-2xl font-semibold">Ponctualité garantie, zéro stress</h2>
          <p>
            Nous savons à quel point chaque minute compte. Que ce soit pour une arrivée à l’aéroport ou une réunion d’affaires, nos chauffeurs sont toujours en avance et suivent en temps réel l’évolution du trafic et des vols.
          </p>
          <p className="italic font-semibold">
            100 % de nos trajets en 2024 ont été assurés à l’heure ou en avance.
          </p>

          <h2 className="text-2xl font-semibold mt-6">Professionnalisme et discrétion absolus</h2>
          <p>Nos chauffeurs sont formés à l’excellence :</p>
          <ul className="list-disc list-inside space-y-1 mb-4">
            <li>Présentation irréprochable</li>
            <li>Conduite fluide et sécurisée</li>
            <li>Communication respectueuse et discrète</li>
            <li>Confidentialité assurée (clients VIP & professionnels)</li>
          </ul>
          <p>Votre confort et votre vie privée sont nos priorités.</p>

          <h2 className="text-2xl font-semibold mt-6">Un transport plus responsable</h2>
          <p>
            Nous sommes conscients de notre empreinte écologique. C’est pourquoi nous investissons dans une flotte de véhicules récents, performants et hybrides, avec une planification des trajets intelligente pour limiter les kilomètres inutiles. <br />
            <strong>Objectif 2025 :</strong> une flotte électrifiée à 50 %.
          </p>

          <h2 className="text-2xl font-semibold mt-6">Une attention particulière pour les familles</h2>
          <p>Les familles en vacances ont des besoins spécifiques :</p>
          <ul className="list-disc list-inside space-y-1 mb-4">
            <li>Sièges enfants disponibles sur demande</li>
            <li>Accueil chaleureux et aide aux bagages</li>
            <li>Climatisation douce, espace spacieux, calme à bord</li>
          </ul>
          <p>Parce que voyager avec des enfants doit rester un plaisir.</p>

          <h2 className="text-2xl font-semibold mt-6">Une réservation simple et un service disponible 7j/7</h2>
          <p>
            Réservez en ligne en quelques clics grâce à notre plateforme intuitive :<br />
            <a
              href="https://montransfert.ch/tarif-reservation"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#deba91] underline"
            >
              https://montransfert.ch/tarif-reservation
            </a>
          </p>
          <p>
            Besoin d’un service personnalisé ou d’un changement de dernière minute ? Notre équipe est joignable 7j/7 pour répondre à vos demandes.
          </p>

          <h2 className="text-2xl font-semibold mt-6">Votre sécurité avant tout</h2>
          <p>Tous nos véhicules sont :</p>
          <ul className="list-disc list-inside space-y-1 mb-4">
            <li>Révisés régulièrement</li>
            <li>Équipés d’assistants de conduite</li>
            <li>Nettoyés et désinfectés entre chaque trajet</li>
          </ul>

          <p>
            Nos chauffeurs sont sélectionnés, formés et assurés, et maîtrisent les trajets les plus complexes.<br />
            Voyagez en toute confiance, en toute saison.
          </p>

          <p className="font-semibold mt-6">
            MonTransfert Sàrl, c’est plus de 50 000 trajets réalisés avec excellence depuis 2016.
          </p>

          <h2 className="text-2xl font-semibold mt-6">Découvrez notre offre complète :</h2>
          <ul className="list-disc list-inside space-y-2">
  <li>
    <a
      href="https://montransfert.ch/flotte"
      className="text-[#deba91] underline"
    >
      Nos véhicules
    </a>
  </li>
  <li>
    <a
      href="https://montransfert.ch/tarif-reservation"
      className="text-[#deba91] underline"
    >
      Tarifs & réservations
    </a>
  </li>
  <li>
    <a
      href="https://montransfert.ch/blog"
      className="text-[#deba91] underline"
    >
      Nos actualités et offres
    </a>
  </li>
</ul>
        </section>
      </div>
    </div>
  );
}
